var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.985 0H7.963C7.155 0 6.5.655 6.5 1.926V55c0 .345.655 1 1.463 1h40.074c.808 0 1.463-.655 1.463-1V12.978c0-.696-.093-.92-.257-1.085L37.607.257A.884.884 0 0036.985 0z",
    fill: "#E9E9E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.037 56H7.963A1.463 1.463 0 016.5 54.537V39h43v15.537c0 .808-.655 1.463-1.463 1.463z",
    fill: "#659C35"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5.151V12h11.849L37.5.151z",
    fill: "#D9D7CA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.385 53h-1.641V42.924h2.898c.428 0 .852.068 1.27.205.42.137.796.342 1.129.615.333.273.602.604.807.991.205.387.308.822.308 1.306 0 .511-.087.973-.26 1.388a2.9 2.9 0 01-.725 1.046c-.31.282-.684.501-1.121.656a4.314 4.314 0 01-1.45.232h-1.216V53zm0-8.832v3.992h1.504c.2 0 .398-.034.595-.103.196-.068.376-.18.54-.335.164-.155.296-.371.396-.649.1-.278.15-.622.15-1.032 0-.164-.023-.354-.068-.567a1.637 1.637 0 00-.28-.615 1.657 1.657 0 00-.595-.492c-.255-.132-.593-.198-1.012-.198h-1.23v-.001zm13.931-1.244V53h-1.668l-3.951-6.945V53h-1.668V42.924h1.668l3.95 6.945v-6.945h1.669zm9.844 4.881v3.896c-.21.265-.444.48-.704.649a4.305 4.305 0 01-1.71.65 6.096 6.096 0 01-.908.068 4.135 4.135 0 01-1.661-.328 3.72 3.72 0 01-1.326-.971c-.378-.429-.675-.966-.89-1.613-.213-.647-.32-1.395-.32-2.242s.107-1.593.32-2.235c.215-.643.51-1.178.89-1.606a3.78 3.78 0 011.333-.978 4.069 4.069 0 011.654-.335c.547 0 1.057.091 1.53.273a3.73 3.73 0 011.272.82l-1.135 1.012a1.951 1.951 0 00-.752-.574 2.252 2.252 0 00-.875-.178c-.337 0-.66.063-.964.191a2.065 2.065 0 00-.82.649c-.242.306-.431.699-.567 1.183-.136.484-.21 1.075-.22 1.777.01.684.08 1.276.213 1.777.132.501.314.911.547 1.23.233.319.497.556.793.711.296.155.608.232.937.232.1 0 .234-.007.403-.021a4.91 4.91 0 00.506-.068 3.29 3.29 0 00.485-.13.695.695 0 00.342-.232v-2.488h-1.71v-1.121h3.337v.002z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.931 19a4.569 4.569 0 100-9.138 4.569 4.569 0 000 9.138z",
    fill: "#F3D55B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 39h43V28l-10-9.5L29 30l-5.483-5.483L6.5 39z",
    fill: "#88C057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.11ce6658ef691e397072327fcc1cfc42.svg";
export { ForwardRef as ReactComponent };